import styled from 'styled-components';

const DangerDescriptionStyle = styled.div`
	--descriptionMaxWidth: var(--sp86x);
	--descriptionSecondSectionFirstChild: var(--sp11x);
	--listPaddingLeft: var(--sp3x);
	--listItemMarginTopBottom: var(--sp1x) 0;

	.descriptions-wrap {
		display: flex;
		flex-wrap: wrap;
		gap: calc(var(--descriptionSecondSectionFirstChild) / 2) var(--descriptionSecondSectionFirstChild);

		.description {
			max-width: var(--descriptionMaxWidth);

			p {
				font-size: var(--p);
				font-family: var(--helvetica);
			}

			strong {
				font-family: var(--helvetica);
				font-weight: 600;
			}

			i {
				font-family: var(--helvetica);
				font-style: italic;
			}

			a {
				text-decoration: underline;
			}

			ul {
				list-style: disc;
				padding-left: var(--listPaddingLeft);

				li {
					font-size: var(--p);
					font-family: var(--helvetica);
					margin: var(--listItemMarginTopBottom);

					&:first-child {
						margin-top: 0;
					}
				}
			}

			ol {
				li {
					font-size: var(--p);
					font-family: var(--helvetica);
					margin: var(--listItemMarginTopBottom);

					&:first-child {
						margin-top: 0;
					}
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--descriptionMaxWidth: var(--sp64x);
		--descriptionSecondSectionFirstChild: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--descriptionMaxWidth: var(--sp50x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--descriptionMaxWidth: var(--sp61x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--descriptionMaxWidth: var(--sp62x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--descriptionMaxWidth: var(--sp52x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--descriptionMaxWidth: var(--sp70x);
		--descriptionSecondSectionFirstChild: 0;

		.descriptions-wrap {
			gap: var(--sp3x);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--descriptionMaxWidth: 100%;
		--descriptionSecondSectionFirstChild: 0;

		.descriptions-wrap {
			gap: var(--sp3x);
		}
	}
`;

export default DangerDescriptionStyle;
